/* PlansEditionDetailsCard.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import { Accordion, BodyNormal, BodySmall, GhostButton, H4, H6 } from '@atlassian/mpac-primitives';
import { editionConstants } from '@atlassian/mpac-utils';
import { useEffect, useState } from 'react';
import { FEATURE_COUNT_FOR_DISPLAY } from '../common/constants';
import { MoreFeaturesLink } from '../common/MoreFeaturesLink';
import { PriceInfoSection } from './PriceInfoSection';
import { calculatePriceAmount } from './utils';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _23 = "._otyr1b66{margin-bottom:var(--ds-space-050,4px)}";
const _22 = "._4cvr1y6m{align-items:flex-start}";
const _21 = "._x3dopp12{border-top:var(--_18x9sjc)}";
const _20 = "._zulputpp{gap:var(--ds-space-150,9pt)}";
const _19 = "._1yt4bd4f{padding:var(--_1f3048p)}";
const _18 = "._18u0idpf{margin-left:0}";
const _17 = "._otyridpf{margin-bottom:0}";
const _16 = "._2hwxidpf{margin-right:0}";
const _15 = "._19pkidpf{margin-top:0}";
const _14 = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const _13 = "@media not all and (min-width:64rem){._6ssj1l60{padding:var(--_1n1l6hd)}}";
const _12 = "._1wpz1fhb{align-self:stretch}";
const _11 = "._1yt4d209{padding:var(--_plnyw1)}";
const _10 = "._zulp1ejb{gap:var(--ds-space-300,24px)}";
const _9 = "@media not all and (min-width:30rem){._mm6d6g4w{min-width:70vw}}";
const _8 = "._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}";
const _7 = "._16jlkb7n{flex-grow:1}";
const _6 = "._2lx21bp4{flex-direction:column}";
const _5 = "._1ul9tye8{min-width:20rem}";
const _4 = "._1bsb10me{width:22.75rem}";
const _3 = "._1e0c1txw{display:flex}";
const _2 = "._19itpp12{border:var(--_18x9sjc)}";
const _ = "._2rko10s1{border-radius:var(--ds-border-radius-200,1pc)}";
const {
  EDITIONS_SUBTITLE_PARTNERS,
  EDITIONS_SUBTITLE_CUSTOMERS,
  EDITIONS_TYPE,
  FEATURES_TITLE,
  TEST_IDS
} = editionConstants;
const cardContainer = null;
const cardTitleAndPriceInfo = null;
const cardTitleContainer = null;
const cardSubtitle = null;
const cardFeaturesListContainer = null;
const featuresLabelText = null;
const {
  EDITION_CARD_TITLE,
  FEATURE_LABEL,
  ACCORDION_LIST_ITEM,
  START_FREE_TRIAL_BUTTON
} = TEST_IDS;
export const PlansEditionDetailsCard = _ref => {
  var _editionDetails$featu;
  let {
    editionDetails,
    billingFrequency,
    teamSize,
    lastTierCeiling,
    source,
    onMoreFeaturesClick,
    startFreeTrialLabel,
    handleStartFreeTrialClick
  } = _ref;
  const [priceDetails, setPriceDetails] = useState({
    amount: 0,
    isFlatAmount: false,
    currentTierFloor: 0,
    currentTierCeiling: 0
  });
  const isPricingTab = source === 'pricingTab';
  useEffect(() => {
    var _editionDetails$prici;
    if (editionDetails !== null && editionDetails !== void 0 && editionDetails.pricingPlan && (_editionDetails$prici = editionDetails.pricingPlan[billingFrequency]) !== null && _editionDetails$prici !== void 0 && _editionDetails$prici.tieredPricing) {
      var _editionDetails$prici2, _editionDetails$prici3;
      const {
        amount,
        isFlatAmount,
        currentTierCeiling,
        currentTierFloor
      } = calculatePriceAmount({
        items: (_editionDetails$prici2 = editionDetails.pricingPlan) === null || _editionDetails$prici2 === void 0 ? void 0 : (_editionDetails$prici3 = _editionDetails$prici2[billingFrequency]) === null || _editionDetails$prici3 === void 0 ? void 0 : _editionDetails$prici3.tieredPricing,
        ceiling: teamSize
      });
      setPriceDetails({
        amount,
        isFlatAmount,
        currentTierCeiling,
        currentTierFloor
      });
    }
  }, [editionDetails, billingFrequency, teamSize]);
  const editionName = EDITIONS_TYPE[editionDetails.type];
  const editionSubtitle = isPricingTab ? EDITIONS_SUBTITLE_CUSTOMERS : EDITIONS_SUBTITLE_PARTNERS;
  const featuresToDisplay = (editionDetails === null || editionDetails === void 0 ? void 0 : (_editionDetails$featu = editionDetails.features) === null || _editionDetails$featu === void 0 ? void 0 : _editionDetails$featu.slice(0, isPricingTab ? FEATURE_COUNT_FOR_DISPLAY : undefined)) || [];
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9]
    }), /*#__PURE__*/_jsxs("section", {
      className: ax(["_2rko10s1 _19itpp12 _1e0c1txw _1bsb10me _1ul9tye8 _2lx21bp4 _16jlkb7n _uiztglyw _mm6d6g4w"]),
      style: {
        "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)"))
      },
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_10, _11, _3, _6, _12, _13]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_zulp1ejb _1yt4d209 _1e0c1txw _2lx21bp4 _1wpz1fhb _6ssj1l60"]),
          style: {
            "--_plnyw1": ix("var(--ds-space-500, 40px)".concat(" ", "var(--ds-space-400, 32px)", " ", "var(--ds-space-400, 32px)")),
            "--_1n1l6hd": ix("var(--ds-space-400, 32px)".concat(" ", "var(--ds-space-400, 32px)", " ", "var(--ds-space-300, 24px)"))
          },
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_14, _3, _6]
            }), /*#__PURE__*/_jsxs("div", {
              className: ax(["_zulp1b66 _1e0c1txw _2lx21bp4"]),
              children: [/*#__PURE__*/_jsx(H4, {
                as: "h3",
                "data-testId": EDITION_CARD_TITLE,
                children: editionName
              }), /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_15, _16, _17, _18]
                }), /*#__PURE__*/_jsx(BodyNormal, {
                  className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf"]),
                  children: editionSubtitle[editionDetails.type]
                })]
              })]
            })]
          }), /*#__PURE__*/_jsx(PriceInfoSection, {
            priceDetails: priceDetails,
            billingFrequency: billingFrequency,
            teamSize: teamSize,
            lastTierCeiling: lastTierCeiling
          }), isPricingTab && /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(GhostButton, {
              "data-testId": START_FREE_TRIAL_BUTTON,
              "aria-label": "".concat(editionName, " plan - Get app now or Start free trial"),
              onClick: () => {
                if (handleStartFreeTrialClick) {
                  handleStartFreeTrialClick(editionDetails.type);
                }
              },
              children: startFreeTrialLabel
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_19, _20, _21, _3, _6, _22]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_1yt4bd4f _zulputpp _x3dopp12 _1e0c1txw _2lx21bp4 _4cvr1y6m"]),
          style: {
            "--_1f3048p": ix("var(--ds-space-300, 24px)".concat(" ", "var(--ds-space-400, 32px)", " ", "var(--ds-space-400, 32px)")),
            "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)"))
          },
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_23]
            }), /*#__PURE__*/_jsx(H6, {
              as: "h4",
              "data-testId": FEATURE_LABEL,
              className: ax(["_otyr1b66"]),
              children: FEATURES_TITLE[editionDetails.type]
            })]
          }), featuresToDisplay.map(_ref2 => {
            let {
              id,
              name,
              description
            } = _ref2;
            return /*#__PURE__*/_jsx(Accordion, {
              title: name,
              testId: ACCORDION_LIST_ITEM,
              children: /*#__PURE__*/_jsx(BodySmall, {
                children: description
              })
            }, id);
          }), isPricingTab && /*#__PURE__*/_jsx(MoreFeaturesLink, {
            editionDetails: editionDetails,
            onClick: () => {
              if (onMoreFeaturesClick) {
                onMoreFeaturesClick();
              }
            }
          })]
        })]
      })]
    })]
  });
};